module.exports = __webpack_public_path__ + "static/img/7.2533784.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/4/zh/7.png
// module id = dVVN
// module chunks = 0